import { connect } from 'react-redux'
import { push } from 'connected-react-router'
import * as action from '../../state/search/action'
import * as selector from '../../state/search/selector'
import SalesOrderSearch from './SalesOrderSearch'

const mapStateToProps = state => {
    return {
        tableData: selector.selectRefinementBookingTable(state),
        type: 'refinement-booking',
    }
}

const mapDispatchToProps = {
    initialTableQuery: action.initialTableQueryRefinementBooking,
    changeFilter: action.changeFilterRefinementBooking,
    toggleSort: action.toggleSortRefinementBooking,
    toggleMultiSort: action.toggleMultiSortRefinementBooking,
    gotoPage: action.gotoPageRefinementBooking,

    navigateToSalesOrder: (salesOrderId) => {
        return push('/sales-order/edit/' + salesOrderId)
    },
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesOrderSearch)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/search/RefinementBookingSalesOrderSearchContainer.js